const Config = {
  NodePath: "https://api.cart7.in",
  devMode: false, //block new orders
  maxItemsQty: 10, //Max Quantity of Items in cart (max per Item)
  ChargePerGram: 0.065,
  minCartValue: 200,
  agentDeliveryCharge: 25,
  confirmationMail: true, //send email to customer, apply for Razorpay auto verification
  whatsAppNumber: "7994030956",
  siteName: "Cart7.in",
  cartExpiryTime: 15, //in minutes
  pincodeValidation: true, //check and save pincode locations
  checkState: false, //block or allow pincodes based on states [States]
}
export default Config;